/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect, useContext } from "react";
import { useParams, Link } from "react-router-dom";
// import HeaderTwo from "../newHeaderTwo";
import Footer from "../../home/footer";
import StickyBox from "react-sticky-box";
import DashboardSidebar from "../sidebar/sidebar";
import { doctor_15, doctorprofileimg } from "../../imagepath";
import { getUserOrders } from "../../../services/orderService";
import { getCelebrities } from "../../../services/celebrityService";
import { AuthContext } from "../../../context/AuthContext";
import { toast } from "react-toastify";
import Navbar from "../../landingpage/sections/Navbar";

const CurrentOrder = (props) => {
    const { orderId } = useParams();
    const { user } = useContext(AuthContext);
    const [order, setOrder] = useState(null);
    const [celebrity, setCelebrity] = useState(null);
    const [loading, setLoading] = useState(true);
    const [recentOrders, setRecentOrders] = useState([]);
    const [allOrders, setAllOrders] = useState([]);
    const [recentOrdersLoading, setRecentOrdersLoading] = useState(false);
    const [celebritiesMap, setCelebritiesMap] = useState({});

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const ordersResponse = await getUserOrders();
                const celebsResponse = await getCelebrities();

                if (celebsResponse.success) {
                    const celebMap = {};
                    celebsResponse.data.forEach(celeb => {
                        celebMap[celeb._id] = celeb;
                    });
                    setCelebritiesMap(celebMap);
                }

                if (ordersResponse && ordersResponse.message === "Fan celebrity requests retrieved successfully") {
                    const orders = ordersResponse.data?.requests || [];
                    setAllOrders(orders);

                    // If we have an orderId, find that specific order
                    if (orderId) {
                        const foundOrder = orders.find(o => o._id === orderId);
                        if (foundOrder) {
                            setOrder(foundOrder);

                            // Get celebrity data - first try from the order itself, then from the map
                            const celebData = foundOrder.celebrity || celebritiesMap[foundOrder.celebrityId?._id || foundOrder.celebrityId];
                            if (celebData) {
                                setCelebrity(celebData);
                            }
                        } else {
                            throw new Error("Order not found");
                        }
                    }

                    // Set recent orders
                    const filteredOrders = orderId
                        ? orders.filter(o => o._id !== orderId).slice(0, 5)
                        : orders.slice(0, 10);
                    setRecentOrders(filteredOrders);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                if (orderId) {
                    toast.error(error.message || "Failed to load order details");
                }
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [orderId]);

    const formatDate = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };

    const formatTime = (dateString) => {
        if (!dateString) return "N/A";
        const date = new Date(dateString);
        return date.toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getYouTubeId = (url) => {
        if (!url) return null;
        if (url.includes('youtube.com/watch?v=')) {
            const videoId = url.split('v=')[1];
            const ampersandPosition = videoId.indexOf('&');
            return ampersandPosition !== -1 ? videoId.substring(0, ampersandPosition) : videoId;
        } else if (url.includes('youtu.be/')) {
            return url.split('youtu.be/')[1];
        }
        return null;
    };

    // Check if order has a video URL (try multiple possible field names)
    const hasVideoUrl = (order) => {
        return order && (order.shoutoutUrl || order.videoUrl || order.url);
    };

    // Get video URL from order (try multiple possible field names)
    const getVideoUrl = (order) => {
        return order?.shoutoutUrl || order?.videoUrl || order?.url;
    };

    // Check if order is completed (try multiple possible status values)
    const isOrderCompleted = (order) => {
        return order && (order.status === 'completed' || order.status === 'approved' || order.status === 'done');
    };

    // Render order list view (when no orderId)
    const renderOrdersList = () => {
        if (allOrders.length === 0) {
            return (
                <div className="account-detail-table">
                    <div className="custom-new-table">
                        <div className="table-header d-flex justify-content-between align-items-center mb-3">
                            {/* <h5>My Orders</h5> */}
                        </div>
                        <div className="text-center py-5">
                            <i className="fa-solid fa-box-open fa-3x text-muted mb-3"></i>
                            {/* <h4>No Orders Yet</h4> */}
                            <p className="text-muted">You haven't placed any orders yet.</p>
                            <Link to="/celebs" className="btn btn-primary">
                                Browse Celebrities
                            </Link>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="recent-appointments">
                {/* <h5 className="head-text">My Orders</h5> */}
                {allOrders.map((orderItem) => {
                    const orderCelebrity = orderItem.celebrity || celebritiesMap[orderItem.celebrityId];

                    return (
                        <div key={orderItem._id} className="appointment-wrap">
                            <ul>
                                <li>
                                    <div className="patinet-information">
                                        <Link to="#">
                                            {orderCelebrity?.profilepicture ? (
                                                <img
                                                    src={orderCelebrity.profilepicture}
                                                    alt={orderCelebrity.displayName}
                                                    className="avatar-img"
                                                    style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                                                    onError={(e) => {
                                                        e.target.src = doctor_15;
                                                    }}
                                                />
                                            ) : (
                                                <img
                                                    src={doctor_15}
                                                    alt="Celebrity"
                                                    style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                                                />
                                            )}
                                        </Link>
                                        <div className="patient-info">
                                            <p>#{orderItem.shortoutId || orderItem._id?.substring(0, 8)}</p>
                                            <h6>
                                                <Link to="#">{orderCelebrity?.displayName || "Unknown Celebrity"}</Link>
                                            </h6>
                                        </div>
                                    </div>
                                </li>
                                <li className="appointment-info">
                                    <p>
                                        <i className="fa-solid fa-clock" />
                                        {formatDate(orderItem.deliveryDate)} {formatTime(orderItem.deliveryDate)}
                                    </p>
                                    <ul className="d-flex apponitment-types">
                                        <li>{orderItem.messageType || "Video"}</li>
                                        {orderItem.recipientName && (
                                            <li>For: {orderItem.recipientName}</li>
                                        )}
                                    </ul>
                                </li>
                                <li className="mail-info-patient">
                                    <ul>
                                        <li>
                                            <i className="fa-solid fa-user" />
                                            {orderCelebrity?.category || "Entertainer"}
                                        </li>
                                        <li>
                                            <span className={`badge bg-${orderItem.status === 'completed' ? 'success' : orderItem.status === 'pending' ? 'warning' : 'primary'}`}>
                                                {orderItem.status || "Processing"}
                                            </span>
                                        </li>
                                    </ul>
                                </li>
                                <li className="appointment-action">
                                    <Link
                                        to={`/order/${orderItem._id}`}
                                        className="btn btn-primary btn-sm"
                                    >
                                        View Details
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    );
                })}
            </div>
        );
    };

    // Render order detail view (when orderId exists)
    const renderOrderDetail = () => {
        if (loading) {
            return (
                <div className="account-detail-table">
                    <div className="custom-new-table">
                        <div className="text-center py-5">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-3">Loading order details...</p>
                        </div>
                    </div>
                </div>
            );
        }

        if (!order) {
            return (
                <div className="account-detail-table">
                    <div className="custom-new-table">
                        <div className="text-center py-5">
                            <i className="fa-solid fa-exclamation-triangle fa-2x text-warning mb-3"></i>
                            <h4>Order Not Found</h4>
                            <p className="text-muted">The requested order could not be found.</p>
                            <Link to="/order" className="btn btn-primary">
                                Back to Orders
                            </Link>
                        </div>
                    </div>
                </div>
            );
        }

        const videoUrl = getVideoUrl(order);
        const isCompleted = isOrderCompleted(order);
        const hasVideo = hasVideoUrl(order);

        return (
            <>
                <div className="dashboard-header">
                    <div className="header-back">
                        <Link to="/order" className="back-arrow">
                            <i className="fa-solid fa-arrow-left" />
                        </Link>
                        <h3>Order Details</h3>
                    </div>
                </div>

                <div className="appointment-details-wrap">
                    {/* Order Detail Card */}
                    <div className="appointment-wrap appointment-detail-card">
                        <ul>
                            <li>
                                <div className="patinet-information">
                                    <Link to="#">
                                        {celebrity?.profilepicture ? (
                                            <img
                                                src={celebrity.profilepicture}
                                                alt={celebrity.displayName}
                                                className="avatar-img"
                                                style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                                                onError={(e) => {
                                                    e.target.src = doctorprofileimg;
                                                }}
                                            />
                                        ) : (
                                            <img
                                                src={doctorprofileimg}
                                                alt="Celebrity"
                                                style={{ width: '80px', height: '80px', objectFit: 'cover' }}
                                            />
                                        )}
                                    </Link>
                                    <div className="patient-info">
                                        <p>#{order.shortoutId || order._id?.substring(0, 8)}</p>
                                        <h6>
                                            <Link to="#">{celebrity?.displayName || "Unknown Celebrity"}</Link>
                                        </h6>
                                        <div className="mail-info-patient">
                                            <ul>
                                                <li>
                                                    <i className="fa-solid fa-star" />
                                                    {celebrity?.category || "Entertainer"}
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </li>
                            <li className="appointment-info">
                                <div className="person-info">
                                    <p>Shoutout Details</p>
                                    <ul className="d-flex apponitment-types">
                                        <li>
                                            <i className="fa-solid fa-gift text-green" />
                                            For: {order.recipientName || "Special Recipient"}
                                        </li>
                                    </ul>
                                </div>
                            </li>
                            <li className="appointment-action">
                                <div className="detail-badge-info">
                                    <span className={`badge bg-${order.status === 'completed' ? 'success' : order.status === 'pending' ? 'warning' : 'primary'}`}>
                                        {order.status || 'Processing'}
                                    </span>
                                </div>
                                <div className="consult-fees">
                                    <h6>Order Status: {order.status || 'Processing'}</h6>
                                </div>
                            </li>
                        </ul>
                        <ul className="detail-card-bottom-info">
                            <li>
                                <h6>Delivery Date</h6>
                                <span>{formatDate(order.deliveryDate)}</span>
                            </li>
                            <li>
                                <h6>Delivery Time</h6>
                                <span>{formatTime(order.deliveryDate)}</span>
                            </li>
                            <li>
                                <h6>Message Type</h6>
                                <span>{order.messageType || "Video"}</span>
                            </li>
                            {order.message && (
                                <li>
                                    <h6>Your Message</h6>
                                    <span className="message-text">{order.message}</span>
                                </li>
                            )}
                            <li>
                                <h6>Order Created</h6>
                                <span>{formatDate(order.createdAt)} at {formatTime(order.createdAt)}</span>
                            </li>
                        </ul>
                    </div>
                    {/* /Order Detail Card */}

                    {/* Video Preview Section */}
                    {isCompleted && hasVideo && (
                        <div className="appointment-wrap appointment-detail-card mt-4">
                            <h5 className="head-text mb-3">Shoutout Video</h5>

                            <div className="form-group">
                                <label className="form-label">Video URL</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={videoUrl}
                                    readOnly
                                />
                                <small className="form-text text-muted">
                                    This is the video shoutout created by the celebrity
                                </small>
                            </div>

                            {/* Video Preview */}
                            <div className="mt-3">
                                <div className="video-preview-container" style={{
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    backgroundColor: '#f8f9fa'
                                }}>
                                    <h6 style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#333' }}>
                                        Video Preview
                                    </h6>

                                    {/* YouTube iframe */}
                                    {videoUrl.includes('youtube.com/') || videoUrl.includes('youtu.be/') ? (
                                        <div style={{
                                            position: 'relative',
                                            paddingBottom: '56.25%', // 16:9 aspect ratio
                                            height: '0',
                                            overflow: 'hidden',
                                            borderRadius: '6px'
                                        }}>
                                            <iframe
                                                src={`https://www.youtube.com/embed/${getYouTubeId(videoUrl)}`}
                                                title={`YouTube video preview for order ${order._id}`}
                                                style={{
                                                    position: 'absolute',
                                                    top: '0',
                                                    left: '0',
                                                    width: '100%',
                                                    height: '100%',
                                                    border: 'none',
                                                    borderRadius: '6px'
                                                }}
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                            />
                                        </div>
                                    ) : (
                                        /* Generic video link preview for non-YouTube */
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '12px',
                                            padding: '10px',
                                            backgroundColor: 'white',
                                            borderRadius: '6px'
                                        }}>
                                            <div style={{
                                                width: '60px',
                                                height: '60px',
                                                backgroundColor: '#007bff',
                                                borderRadius: '6px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                color: 'white',
                                                fontSize: '24px'
                                            }}>
                                                <i className="fa-solid fa-play"></i>
                                            </div>
                                            <div style={{ flex: 1 }}>
                                                <p style={{
                                                    margin: '0 0 4px 0',
                                                    fontSize: '12px',
                                                    color: '#666',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap'
                                                }}>
                                                    {videoUrl}
                                                </p>
                                                <a
                                                    href={videoUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    style={{
                                                        fontSize: '12px',
                                                        color: '#007bff',
                                                        textDecoration: 'none'
                                                    }}
                                                >
                                                    <i className="fa-solid fa-arrow-up-right-from-square me-1"></i>
                                                    Open video in new tab
                                                </a>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="mt-3">
                                <a
                                    href={videoUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-primary"
                                >
                                    <i className="fa-solid fa-external-link-alt me-2"></i>
                                    Open Video
                                </a>
                            </div>
                        </div>
                    )}

                    {recentOrders.length > 0 && (
                        <div className="recent-appointments">
                            <h5 className="head-text">Other Orders</h5>
                            {recentOrders.map((recentOrder) => {
                                const recentCelebrity = recentOrder.celebrity || celebritiesMap[recentOrder.celebrityId?._id || recentOrder.celebrityId];

                                return (
                                    <div key={recentOrder._id} className="appointment-wrap">
                                        <ul>
                                            <li>
                                                <div className="patinet-information">
                                                    <Link to="#">
                                                        {recentCelebrity?.profilepicture ? (
                                                            <img
                                                                src={recentCelebrity.profilepicture}
                                                                alt={recentCelebrity.displayName}
                                                                className="avatar-img"
                                                                style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                                                                onError={(e) => {
                                                                    e.target.src = doctor_15;
                                                                }}
                                                            />
                                                        ) : (
                                                            <img
                                                                src={doctor_15}
                                                                alt="Celebrity"
                                                                style={{ width: '40px', height: '40px', objectFit: 'cover' }}
                                                            />
                                                        )}
                                                    </Link>
                                                    <div className="patient-info">
                                                        <p>#{recentOrder.shortoutId || recentOrder._id?.substring(0, 8)}</p>
                                                        <h6>
                                                            <Link to="#">{recentCelebrity?.displayName || "Unknown Celebrity"}</Link>
                                                        </h6>
                                                    </div>
                                                </div>
                                            </li>
                                            <li className="appointment-info">
                                                <p>
                                                    <i className="fa-solid fa-clock" />
                                                    {formatDate(recentOrder.deliveryDate)} {formatTime(recentOrder.deliveryDate)}
                                                </p>
                                                <ul className="d-flex apponitment-types">
                                                    <li>{recentOrder.messageType || "Video"}</li>
                                                    {recentOrder.recipientName && (
                                                        <li>For: {recentOrder.recipientName}</li>
                                                    )}
                                                </ul>
                                            </li>
                                            <li className="mail-info-patient">
                                                <ul>
                                                    <li>
                                                        <i className="fa-solid fa-user" />
                                                        {recentCelebrity?.category || "Entertainer"}
                                                    </li>
                                                    <li>
                                                        <span className={`badge bg-${recentOrder.status === 'completed' ? 'success' : recentOrder.status === 'pending' ? 'warning' : 'primary'}`}>
                                                            {recentOrder.status || "Processing"}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </li>
                                            <li className="appointment-action">
                                                <Link
                                                    to={`/order/${recentOrder._id}`}
                                                    className="btn btn-primary btn-sm"
                                                >
                                                    View Details
                                                </Link>
                                            </li>
                                        </ul>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>
            </>
        );
    };

    // Determine which view to show
    const showDetailView = orderId;

    return (
        <div className="main-wrapper">
            <Navbar {...props} />

            {/* Fixed Breadcrumb Section */}
            <div className="breadcrumb-bar"
                style={{
                    backgroundColor: 'var(--breadcrumb-bg)',
                    transition: 'background-color 0.3s ease'
                }}
            >
                <div className="container">
                    <div className="row align-items-center inner-banner">
                        <div className="col-md-12 col-12 text-center">
                            <h2 className="breadcrumb-title">
                                {showDetailView ? "Order Details" : "My Orders"}
                            </h2>
                            <nav aria-label="breadcrumb" className="page-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/fan-dashboard">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        {showDetailView
                                            ? `Order #${order?.shortoutId || order?._id?.substring(0, 8) || ''}`
                                            : "My Orders"}
                                    </li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            <StickyBox offsetTop={20} offsetBottom={20}>
                                <DashboardSidebar />
                            </StickyBox>
                        </div>

                        <div className="col-lg-8 col-xl-9">
                            {/* Add proper dashboard header like in FanAccounts */}
                            <div className="dashboard-header">
                                <div className="header-back">
                                    <h3>{showDetailView ? "Order Details" : "My Orders"}</h3>
                                </div>
                            </div>

                            {/* Main content area with proper container */}
                            <div className="accunts-sec">
                                {showDetailView ? renderOrderDetail() : renderOrdersList()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer {...props} />
        </div>
    );
};

export default CurrentOrder;


// /* eslint-disable react-hooks/exhaustive-deps */
// /* eslint-disable no-unused-vars */
// import React, { useState, useEffect, useContext } from "react";
// import { useParams, Link } from "react-router-dom";
// import HeaderTwo from "../newHeaderTwo";
// import Footer from "../../home/footer";
// import StickyBox from "react-sticky-box";
// import DashboardSidebar from "../sidebar/sidebar";
// import { doctor_15, doctorprofileimg } from "../../imagepath";
// import { getUserOrders } from "../../../services/orderService";
// import { getCelebrities } from "../../../services/celebrityService";
// import { AuthContext } from "../../../context/AuthContext";
// import { toast } from "react-toastify";

// const CurrentOrder = (props) => {
//     const { orderId } = useParams();
//     const { user } = useContext(AuthContext);
//     const [order, setOrder] = useState(null);
//     const [celebrity, setCelebrity] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [recentOrders, setRecentOrders] = useState([]);
//     const [allOrders, setAllOrders] = useState([]);
//     const [recentOrdersLoading, setRecentOrdersLoading] = useState(false);
//     const [celebritiesMap, setCelebritiesMap] = useState({});

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 setLoading(true);
//                 const ordersResponse = await getUserOrders();
//                 const celebsResponse = await getCelebrities();

//                 if (celebsResponse.success) {
//                     const celebMap = {};
//                     celebsResponse.data.forEach(celeb => {
//                         celebMap[celeb._id] = celeb;
//                     });
//                     setCelebritiesMap(celebMap);
//                 }

//                 if (ordersResponse && ordersResponse.message === "Fan celebrity requests retrieved successfully") {
//                     const orders = ordersResponse.data?.requests || [];
//                     setAllOrders(orders);

//                     // If we have an orderId, find that specific order
//                     if (orderId) {
//                         const foundOrder = orders.find(o => o._id === orderId);
//                         if (foundOrder) {
//                             setOrder(foundOrder);

//                             // Get celebrity data - first try from the order itself, then from the map
//                             const celebData = foundOrder.celebrity || celebritiesMap[foundOrder.celebrityId?._id || foundOrder.celebrityId];
//                             if (celebData) {
//                                 setCelebrity(celebData);
//                             }
//                         } else {
//                             throw new Error("Order not found");
//                         }
//                     }

//                     // Set recent orders
//                     const filteredOrders = orderId
//                         ? orders.filter(o => o._id !== orderId).slice(0, 5)
//                         : orders.slice(0, 10);
//                     setRecentOrders(filteredOrders);
//                 }
//             } catch (error) {
//                 console.error("Error fetching data:", error);
//                 if (orderId) {
//                     toast.error(error.message || "Failed to load order details");
//                 }
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchData();
//     }, [orderId]);

//     const formatDate = (dateString) => {
//         if (!dateString) return "N/A";
//         const date = new Date(dateString);
//         return date.toLocaleDateString('en-US', {
//             year: 'numeric',
//             month: 'short',
//             day: 'numeric'
//         });
//     };

//     const formatTime = (dateString) => {
//         if (!dateString) return "N/A";
//         const date = new Date(dateString);
//         return date.toLocaleTimeString('en-US', {
//             hour: '2-digit',
//             minute: '2-digit'
//         });
//     };

//     const getYouTubeId = (url) => {
//         if (!url) return null;
//         if (url.includes('youtube.com/watch?v=')) {
//             const videoId = url.split('v=')[1];
//             const ampersandPosition = videoId.indexOf('&');
//             return ampersandPosition !== -1 ? videoId.substring(0, ampersandPosition) : videoId;
//         } else if (url.includes('youtu.be/')) {
//             return url.split('youtu.be/')[1];
//         }
//         return null;
//     };

//     // Check if order has a video URL (try multiple possible field names)
//     const hasVideoUrl = (order) => {
//         return order && (order.shoutoutUrl || order.videoUrl || order.url);
//     };

//     // Get video URL from order (try multiple possible field names)
//     const getVideoUrl = (order) => {
//         return order?.shoutoutUrl || order?.videoUrl || order?.url;
//     };

//     // Check if order is completed (try multiple possible status values)
//     const isOrderCompleted = (order) => {
//         return order && (order.status === 'completed' || order.status === 'approved' || order.status === 'done');
//     };

//     // Render order list view (when no orderId)
//     const renderOrdersList = () => {
//         if (allOrders.length === 0) {
//             return (
//                 <div className="text-center py-5">
//                     <i className="fa-solid fa-box-open fa-3x text-muted mb-3"></i>
//                     <h4>No Orders Yet</h4>
//                     <p className="text-muted">You haven't placed any orders yet.</p>
//                     <Link to="/celebs" className="btn btn-primary">
//                         Browse Celebrities
//                     </Link>
//                 </div>
//             );
//         }

//         return (
//             <div className="recent-appointments">
//                 <h5 className="head-text">My Orders</h5>
//                 {allOrders.map((orderItem) => {
//                     const orderCelebrity = orderItem.celebrity || celebritiesMap[orderItem.celebrityId];

//                     return (
//                         <div key={orderItem._id} className="appointment-wrap">
//                             <ul>
//                                 <li>
//                                     <div className="patinet-information">
//                                         <Link to="#">
//                                             {orderCelebrity?.profilepicture ? (
//                                                 <img
//                                                     src={orderCelebrity.profilepicture}
//                                                     alt={orderCelebrity.displayName}
//                                                     className="avatar-img"
//                                                     style={{ width: '40px', height: '40px', objectFit: 'cover' }}
//                                                     onError={(e) => {
//                                                         e.target.src = doctor_15;
//                                                     }}
//                                                 />
//                                             ) : (
//                                                 <img
//                                                     src={doctor_15}
//                                                     alt="Celebrity"
//                                                     style={{ width: '40px', height: '40px', objectFit: 'cover' }}
//                                                 />
//                                             )}
//                                         </Link>
//                                         <div className="patient-info">
//                                             <p>#{orderItem.shortoutId || orderItem._id?.substring(0, 8)}</p>
//                                             <h6>
//                                                 <Link to="#">{orderCelebrity?.displayName || "Unknown Celebrity"}</Link>
//                                             </h6>
//                                         </div>
//                                     </div>
//                                 </li>
//                                 <li className="appointment-info">
//                                     <p>
//                                         <i className="fa-solid fa-clock" />
//                                         {formatDate(orderItem.deliveryDate)} {formatTime(orderItem.deliveryDate)}
//                                     </p>
//                                     <ul className="d-flex apponitment-types">
//                                         <li>{orderItem.messageType || "Video"}</li>
//                                         {orderItem.recipientName && (
//                                             <li>For: {orderItem.recipientName}</li>
//                                         )}
//                                     </ul>
//                                 </li>
//                                 <li className="mail-info-patient">
//                                     <ul>
//                                         <li>
//                                             <i className="fa-solid fa-user" />
//                                             {orderCelebrity?.category || "Entertainer"}
//                                         </li>
//                                         <li>
//                                             <span className={`badge bg-${orderItem.status === 'completed' ? 'success' : orderItem.status === 'pending' ? 'warning' : 'primary'}`}>
//                                                 {orderItem.status || "Processing"}
//                                             </span>
//                                         </li>
//                                     </ul>
//                                 </li>
//                                 <li className="appointment-action">
//                                     <Link
//                                         to={`/order/${orderItem._id}`}
//                                         className="btn btn-primary btn-sm"
//                                     >
//                                         View Details
//                                     </Link>
//                                 </li>
//                             </ul>
//                         </div>
//                     );
//                 })}
//             </div>
//         );
//     };

//     // Render order detail view (when orderId exists)
//     const renderOrderDetail = () => {
//         if (loading) {
//             return (
//                 <div className="text-center py-5">
//                     <div className="spinner-border text-primary" role="status">
//                         <span className="visually-hidden">Loading...</span>
//                     </div>
//                     <p className="mt-3">Loading order details...</p>
//                 </div>
//             );
//         }

//         if (!order) {
//             return (
//                 <div className="text-center py-5">
//                     <i className="fa-solid fa-exclamation-triangle fa-2x text-warning mb-3"></i>
//                     <h4>Order Not Found</h4>
//                     <p className="text-muted">The requested order could not be found.</p>
//                     <Link to="/order" className="btn btn-primary">
//                         Back to Orders
//                     </Link>
//                 </div>
//             );
//         }

//         const videoUrl = getVideoUrl(order);
//         const isCompleted = isOrderCompleted(order);
//         const hasVideo = hasVideoUrl(order);

//         return (
//             <>
//                 <div className="dashboard-header">
//                     <div className="header-back">
//                         <Link to="/order" className="back-arrow">
//                             <i className="fa-solid fa-arrow-left" />
//                         </Link>
//                         <h3>Order Details</h3>
//                     </div>
//                 </div>

//                 <div className="appointment-details-wrap">
//                     {/* Order Detail Card */}
//                     <div className="appointment-wrap appointment-detail-card">
//                         <ul>
//                             <li>
//                                 <div className="patinet-information">
//                                     <Link to="#">
//                                         {celebrity?.profilepicture ? (
//                                             <img
//                                                 src={celebrity.profilepicture}
//                                                 alt={celebrity.displayName}
//                                                 className="avatar-img"
//                                                 style={{ width: '80px', height: '80px', objectFit: 'cover' }}
//                                                 onError={(e) => {
//                                                     e.target.src = doctorprofileimg;
//                                                 }}
//                                             />
//                                         ) : (
//                                             <img
//                                                 src={doctorprofileimg}
//                                                 alt="Celebrity"
//                                                 style={{ width: '80px', height: '80px', objectFit: 'cover' }}
//                                             />
//                                         )}
//                                     </Link>
//                                     <div className="patient-info">
//                                         <p>#{order.shortoutId || order._id?.substring(0, 8)}</p>
//                                         <h6>
//                                             <Link to="#">{celebrity?.displayName || "Unknown Celebrity"}</Link>
//                                         </h6>
//                                         <div className="mail-info-patient">
//                                             <ul>
//                                                 <li>
//                                                     <i className="fa-solid fa-star" />
//                                                     {celebrity?.category || "Entertainer"}
//                                                 </li>
//                                             </ul>
//                                         </div>
//                                     </div>
//                                 </div>
//                             </li>
//                             <li className="appointment-info">
//                                 <div className="person-info">
//                                     <p>Shoutout Details</p>
//                                     <ul className="d-flex apponitment-types">
//                                         <li>
//                                             <i className="fa-solid fa-gift text-green" />
//                                             For: {order.recipientName || "Special Recipient"}
//                                         </li>
//                                     </ul>
//                                 </div>
//                             </li>
//                             <li className="appointment-action">
//                                 <div className="detail-badge-info">
//                                     <span className={`badge bg-${order.status === 'completed' ? 'success' : order.status === 'pending' ? 'warning' : 'primary'}`}>
//                                         {order.status || 'Processing'}
//                                     </span>
//                                 </div>
//                                 <div className="consult-fees">
//                                     <h6>Order Status: {order.status || 'Processing'}</h6>
//                                 </div>
//                             </li>
//                         </ul>
//                         <ul className="detail-card-bottom-info">
//                             <li>
//                                 <h6>Delivery Date</h6>
//                                 <span>{formatDate(order.deliveryDate)}</span>
//                             </li>
//                             <li>
//                                 <h6>Delivery Time</h6>
//                                 <span>{formatTime(order.deliveryDate)}</span>
//                             </li>
//                             <li>
//                                 <h6>Message Type</h6>
//                                 <span>{order.messageType || "Video"}</span>
//                             </li>
//                             {order.message && (
//                                 <li>
//                                     <h6>Your Message</h6>
//                                     <span className="message-text">{order.message}</span>
//                                 </li>
//                             )}
//                             <li>
//                                 <h6>Order Created</h6>
//                                 <span>{formatDate(order.createdAt)} at {formatTime(order.createdAt)}</span>
//                             </li>
//                         </ul>
//                     </div>
//                     {/* /Order Detail Card */}

//                     {/* Video Preview Section */}
//                     {isCompleted && hasVideo && (
//                         <div className="appointment-wrap appointment-detail-card mt-4">
//                             <h5 className="head-text mb-3">Shoutout Video</h5>

//                             <div className="form-group">
//                                 <label className="form-label">Video URL</label>
//                                 <input
//                                     type="text"
//                                     className="form-control"
//                                     value={videoUrl}
//                                     readOnly
//                                 />
//                                 <small className="form-text text-muted">
//                                     This is the video shoutout created by the celebrity
//                                 </small>
//                             </div>

//                             {/* Video Preview */}
//                             <div className="mt-3">
//                                 <div className="video-preview-container" style={{
//                                     border: '1px solid #e0e0e0',
//                                     borderRadius: '8px',
//                                     padding: '12px',
//                                     backgroundColor: '#f8f9fa'
//                                 }}>
//                                     <h6 style={{ margin: '0 0 10px 0', fontSize: '14px', color: '#333' }}>
//                                         Video Preview
//                                     </h6>

//                                     {/* YouTube iframe */}
//                                     {videoUrl.includes('youtube.com/') || videoUrl.includes('youtu.be/') ? (
//                                         <div style={{
//                                             position: 'relative',
//                                             paddingBottom: '56.25%', // 16:9 aspect ratio
//                                             height: '0',
//                                             overflow: 'hidden',
//                                             borderRadius: '6px'
//                                         }}>
//                                             <iframe
//                                                 src={`https://www.youtube.com/embed/${getYouTubeId(videoUrl)}`}
//                                                 title={`YouTube video preview for order ${order._id}`}
//                                                 style={{
//                                                     position: 'absolute',
//                                                     top: '0',
//                                                     left: '0',
//                                                     width: '100%',
//                                                     height: '100%',
//                                                     border: 'none',
//                                                     borderRadius: '6px'
//                                                 }}
//                                                 allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
//                                                 allowFullScreen
//                                             />
//                                         </div>
//                                     ) : (
//                                         /* Generic video link preview for non-YouTube */
//                                         <div style={{
//                                             display: 'flex',
//                                             alignItems: 'center',
//                                             gap: '12px',
//                                             padding: '10px',
//                                             backgroundColor: 'white',
//                                             borderRadius: '6px'
//                                         }}>
//                                             <div style={{
//                                                 width: '60px',
//                                                 height: '60px',
//                                                 backgroundColor: '#007bff',
//                                                 borderRadius: '6px',
//                                                 display: 'flex',
//                                                 alignItems: 'center',
//                                                 justifyContent: 'center',
//                                                 color: 'white',
//                                                 fontSize: '24px'
//                                             }}>
//                                                 <i className="fa-solid fa-play"></i>
//                                             </div>
//                                             <div style={{ flex: 1 }}>
//                                                 <p style={{
//                                                     margin: '0 0 4px 0',
//                                                     fontSize: '12px',
//                                                     color: '#666',
//                                                     overflow: 'hidden',
//                                                     textOverflow: 'ellipsis',
//                                                     whiteSpace: 'nowrap'
//                                                 }}>
//                                                     {videoUrl}
//                                                 </p>
//                                                 <a
//                                                     href={videoUrl}
//                                                     target="_blank"
//                                                     rel="noopener noreferrer"
//                                                     style={{
//                                                         fontSize: '12px',
//                                                         color: '#007bff',
//                                                         textDecoration: 'none'
//                                                     }}
//                                                 >
//                                                     <i className="fa-solid fa-arrow-up-right-from-square me-1"></i>
//                                                     Open video in new tab
//                                                 </a>
//                                             </div>
//                                         </div>
//                                     )}
//                                 </div>
//                             </div>

//                             <div className="mt-3">
//                                 <a
//                                     href={videoUrl}
//                                     target="_blank"
//                                     rel="noopener noreferrer"
//                                     className="btn btn-primary"
//                                 >
//                                     <i className="fa-solid fa-external-link-alt me-2"></i>
//                                     Open Video
//                                 </a>
//                             </div>
//                         </div>
//                     )}

//                     {recentOrders.length > 0 && (
//                         <div className="recent-appointments">
//                             <h5 className="head-text">Other Orders</h5>
//                             {recentOrders.map((recentOrder) => {
//                                 const recentCelebrity = recentOrder.celebrity || celebritiesMap[recentOrder.celebrityId?._id || recentOrder.celebrityId];

//                                 return (
//                                     <div key={recentOrder._id} className="appointment-wrap">
//                                         <ul>
//                                             <li>
//                                                 <div className="patinet-information">
//                                                     <Link to="#">
//                                                         {recentCelebrity?.profilepicture ? (
//                                                             <img
//                                                                 src={recentCelebrity.profilepicture}
//                                                                 alt={recentCelebrity.displayName}
//                                                                 className="avatar-img"
//                                                                 style={{ width: '40px', height: '40px', objectFit: 'cover' }}
//                                                                 onError={(e) => {
//                                                                     e.target.src = doctor_15;
//                                                                 }}
//                                                             />
//                                                         ) : (
//                                                             <img
//                                                                 src={doctor_15}
//                                                                 alt="Celebrity"
//                                                                 style={{ width: '40px', height: '40px', objectFit: 'cover' }}
//                                                             />
//                                                         )}
//                                                     </Link>
//                                                     <div className="patient-info">
//                                                         <p>#{recentOrder.shortoutId || recentOrder._id?.substring(0, 8)}</p>
//                                                         <h6>
//                                                             <Link to="#">{recentCelebrity?.displayName || "Unknown Celebrity"}</Link>
//                                                         </h6>
//                                                     </div>
//                                                 </div>
//                                             </li>
//                                             <li className="appointment-info">
//                                                 <p>
//                                                     <i className="fa-solid fa-clock" />
//                                                     {formatDate(recentOrder.deliveryDate)} {formatTime(recentOrder.deliveryDate)}
//                                                 </p>
//                                                 <ul className="d-flex apponitment-types">
//                                                     <li>{recentOrder.messageType || "Video"}</li>
//                                                     {recentOrder.recipientName && (
//                                                         <li>For: {recentOrder.recipientName}</li>
//                                                     )}
//                                                 </ul>
//                                             </li>
//                                             <li className="mail-info-patient">
//                                                 <ul>
//                                                     <li>
//                                                         <i className="fa-solid fa-user" />
//                                                         {recentCelebrity?.category || "Entertainer"}
//                                                     </li>
//                                                     <li>
//                                                         <span className={`badge bg-${recentOrder.status === 'completed' ? 'success' : recentOrder.status === 'pending' ? 'warning' : 'primary'}`}>
//                                                             {recentOrder.status || "Processing"}
//                                                         </span>
//                                                     </li>
//                                                 </ul>
//                                             </li>
//                                             <li className="appointment-action">
//                                                 <Link
//                                                     to={`/order/${recentOrder._id}`}
//                                                     className="btn btn-primary btn-sm"
//                                                 >
//                                                     View Details
//                                                 </Link>
//                                             </li>
//                                         </ul>
//                                     </div>
//                                 );
//                             })}
//                         </div>
//                     )}
//                 </div>
//             </>
//         );
//     };

//     // Determine which view to show
//     const showDetailView = orderId;

//     return (
//         <div className="main-wrapper">
//             <HeaderTwo {...props} />

//             {/* Fixed Breadcrumb Section */}
//             <div className="breadcrumb-bar"
//                 style={{
//                     backgroundColor: 'var(--breadcrumb-bg)',
//                     transition: 'background-color 0.3s ease'
//                 }}
//             >
//                 <div className="container">
//                     <div className="row align-items-center inner-banner">
//                         <div className="col-md-12 col-12 text-center">
//                             <h2 className="breadcrumb-title">
//                                 {showDetailView ? "Order Details" : "My Orders"}
//                             </h2>
//                             <nav aria-label="breadcrumb" className="page-breadcrumb">
//                                 <ol className="breadcrumb">
//                                     <li className="breadcrumb-item">
//                                         <Link to="/">Home</Link>
//                                     </li>
//                                     <li className="breadcrumb-item">
//                                         <Link to="/fan-dashboard">Dashboard</Link>
//                                     </li>
//                                     <li className="breadcrumb-item active">
//                                         {showDetailView
//                                             ? `Order #${order?.shortoutId || order?._id?.substring(0, 8) || ''}`
//                                             : "My Orders"}
//                                     </li>
//                                 </ol>
//                             </nav>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <div className="content">
//                 <div className="container-fluid">
//                     <div className="row">
//                         <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
//                             <StickyBox offsetTop={20} offsetBottom={20}>
//                                 <DashboardSidebar />
//                             </StickyBox>
//                         </div>

//                         <div className="col-lg-8 col-xl-9">
//                             {showDetailView ? renderOrderDetail() : renderOrdersList()}
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <Footer {...props} />
//         </div>
//     );
// };

// export default CurrentOrder;

